import { Hotel, getReferenceCurrency } from 'tokyu-hooks'
import type { GetRoomPlanAvailabilityResponse } from 'tokyu-hooks/lib/response/hotel'

export const FETCH_ROOM_PLAN_AVAILABILITY = 'FETCH_ROOM_PLAN_AVAILABILITY'

export const fetchRoomPlanAvailability =
  (clientSession: string) =>
  async ({
    queryKey,
  }: {
    queryKey: any[]
  }): Promise<GetRoomPlanAvailabilityResponse['data'] | null> => {
    const [
      _key,
      {
        hotelId,
        roomPlanCode,
        nights,
        adults,
        children,
        startDate,
        endDate,
        locale,
      },
    ] = queryKey

    if (!hotelId || !roomPlanCode || !startDate || !endDate) return null

    const res = await Hotel.getRoomPlanAvailability({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession,
      locale,
      hotel_id: String(hotelId),
      start_date: startDate,
      end_date: endDate,
      nights,
      room_plan_code: roomPlanCode,
      adults,
      children,
      mcp_currency: getReferenceCurrency(locale),
    })

    return res?.data ?? null
  }
